const MODULE_TYPE = {
    form: 'form',
    cardTable: 'cardTable',
    editTable: 'editTable',
};

export {
    MODULE_TYPE,
};